import { IconStyle } from './styled'

function Icon({ iconName, onFn }) {
  return <IconStyle data-icon={iconName} onClick={onFn} />
}

export { Icon }
